import { render, staticRenderFns } from "./assistant-first-trial-dialog.vue?vue&type=template&id=3f545322&scoped=true&"
import script from "./assistant-first-trial-dialog.vue?vue&type=script&lang=js&"
export * from "./assistant-first-trial-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f545322",
  null
  
)

export default component.exports